module.exports = __webpack_public_path__ + "img/circle-up.8291d940.svg";